// Número de WhatsApp del administrador que recibe las solicitudes de cotización
// y los avisos de aceptación de las enfermeras. Mismo número usado en el botón
// flotante de WhatsApp del sitio (elements/WhatsAppButton.tsx).
export const ADMIN_WHATSAPP = '56957285973';

export const RANGO_HORARIO_LABELS: Record<string, string> = {
  manana: 'Mañana (08:00 - 12:00)',
  tarde: 'Tarde (12:00 - 17:00)',
  tarde_noche: 'Tarde-noche (17:00 - 21:00)',
  todo_dia: 'Todo el día (08:00 - 21:00)',
};

// Mismas opciones que RANGO_HORARIO_LABELS, en formato lista para poblar un
// <Select>. Usado tanto por el horario deseado del paciente (QuoteForm) como
// por el horario de disponibilidad que declara la enfermera (NurseQuoteView).
export const RANGOS_HORARIOS_OPTIONS = [
  { value: 'manana', label: 'Mañana (08:00 - 12:00)' },
  { value: 'tarde', label: 'Tarde (12:00 - 17:00)' },
  { value: 'tarde_noche', label: 'Tarde-noche (17:00 - 21:00)' },
  { value: 'todo_dia', label: 'Todo el día (08:00 - 21:00)' },
  { value: 'personalizado', label: 'Otro horario (especificar)' },
];

// Etiquetas legibles para las respuestas de los campos específicos por
// procedimiento (ver CAMPOS_POR_PROCEDIMIENTO en QuoteForm.tsx). Se usan para
// mostrar `campos_especificos` en el panel de admin y en la vista de la enfermera.
export const CAMPOS_ESPECIFICOS_LABELS: Record<string, string> = {
  tipo_inyeccion: 'Tipo de inyección',
  cantidad: 'Cantidad',
  medicamentos_inyectar: 'Medicamentos a inyectar',
  tiene_medicamento: '¿Tiene el medicamento?',
  tiene_orden_medica: '¿Tiene orden médica?',
  tiene_placas_materiales: '¿Cuenta con placas y materiales para el cambio?',
  tipo_sonda: 'Tipo de sonda',
  tiene_sonda_materiales: '¿Cuenta con la sonda y materiales?',
  indicacion_medica: 'Indicación médica para el retiro',
  diagnostico_herida: 'Diagnóstico o tipo de herida',
  tiene_insumos_tratamiento: '¿Cuenta con los insumos para el tratamiento?',
  tiene_orden_medica_tratamiento: '¿Cuenta con orden médica?',
};

export const PROCEDIMIENTO_LABELS: Record<string, string> = {
  curacion_simple: 'Curación simple',
  curacion_avanzada: 'Curación avanzada de heridas',
  ostomia: 'Ostomía',
  sondas: 'Sondas',
  retiro_puntos: 'Retiro de puntos',
  inyecciones: 'Inyecciones',
  tratamiento_endovenoso: 'Tratamiento endovenoso / Sueroterapia',
  asesoria_online: 'Asesoría online',
  otro: 'Otro procedimiento',
};

// Tabla de comisiones de la plataforma por procedimiento (CLP).
// Los procedimientos que no aparecen aquí no tienen comisión fija — la enfermera
// debe consultar con administración.
export const COMISION_POR_PROCEDIMIENTO: Record<string, number> = {
  curacion_avanzada: 5000,
  tratamiento_endovenoso: 4000,
  curacion_simple: 3500,
  ostomia: 3500,
  retiro_puntos: 3000,
  inyecciones: 3000,
};

